import { renderV2WhenReady } from './captcha-google.js';
import {fetchCsrfToken} from '../csrf-token-module.js';

window.addEventListener('load', () => {
  renderV2WhenReady('recaptcha-v2-challenge');

  const captchaForm = document.getElementById('js-verify-captcha-form');
  if (captchaForm) {
    captchaForm.addEventListener('submit', function(event) {
      submitCaptchaForm(event, captchaForm);
    });
  }
});

function submitCaptchaForm(event, captchaForm) {
  event.preventDefault();

  const captchaError = document.getElementById('js-captcha-error');

  captchaError.innerHTML = '&nbsp;';
  fetch('/shopController.php?objective=checkcaptcha', {
    method: 'POST',
    body: new FormData(captchaForm),
    headers: {'X-CSRF-Token': fetchCsrfToken()},
  }).then((response) => {
    response.json().then((data) => {
      if (data.success) {
        window.location.href = data.origin;
      } else {
        let errorMessage = 'Es gab ein Problem bei der Captcha-Verifizierung. Bitte versuche es erneut.';
        if (data.error) {
          errorMessage = data.error;
        }

        captchaError.innerHTML = errorMessage;
      }
    });
  });
}